import { observable, action, computed } from 'mobx';
import { ReqInputMsg, Addition, callCmd } from 'lib/reqInputMsg';
import { notification, Modal } from 'antd';

export default class OrderStore {
  constructor(root) {
    this.root = root;
  }

  //----------------------------------
  /* Mainstore에서 세션만료 처리하기위해 */
  @observable
  _commonStoreInfo = null;

  @computed
  get commonStoreInfo() {
    return this._commonStoreInfo;
  }

  @action
  setCommonStoreInfo = (storeInfo) => {
    this._commonStoreInfo = storeInfo;
  };

  //----------------------------------
  @action
  onClear = () => {
    // 사원리스트
    this._userList = [];
    this._pageInfo = null;
    this._valCondition = {
      exceptionYn: 'N', // 예외주문여부
      userNm: '',
  
      pageIdx: 1,
      recordCountPerPage: 15,

      // 선택한 회사 타입, 코드
      selectType: '',
      selectCeCd: ''
    };
    this._userListLoding = false;
    this._selUserInfo = {
      userId: '',
      jobCd: '',
      userSex: ''
    };

    // 상품리스트
    this._goodsList = [];

    // 장바구니 관련
    this._cartList = [];
    this._modalOpenCart = false;
    this._failAlert = false;
  };

  //-----------------------------------
  //  주문하기
  //-----------------------------------
  @action
  addOrderList = async (orderInfo) => {
    let addition = new Addition();
    addition.setCmdName('ADD-ORDER-LIST');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'orAddr', paraValue: orderInfo?.orAddr || ''});
    reqInputMsg.addParam({paraName: 'orAddrDetail', paraValue: orderInfo?.orAddrDetail || ''});
    reqInputMsg.addParam({paraName: 'orZipCd', paraValue: orderInfo?.orZipCd || ''});
    reqInputMsg.addParam({paraName: 'picNm', paraValue: orderInfo?.picNm || ''});
    reqInputMsg.addParam({paraName: 'picHp', paraValue: orderInfo?.picHp || ''});
    reqInputMsg.addParam({paraName: 'mgrUserId', paraValue: orderInfo?.mgrUserId || ''});
    reqInputMsg.addParam({paraName: 'mgrUserNm', paraValue: orderInfo?.mgrUserNm || ''});
    reqInputMsg.addParam({paraName: 'mgrUserHp', paraValue: orderInfo?.mgrUserHp || ''});
    reqInputMsg.addParam({paraName: 'officeNm', paraValue: orderInfo?.officeNm || ''});
    reqInputMsg.addParam({paraName: 'orStat', paraValue: orderInfo?.orStat || ''});        
    // 서버에서 장바구니 리스트를 불러오기 위해
    reqInputMsg.addParam({paraName: 'exceptionYn', paraValue: this._valCondition.exceptionYn});
    reqInputMsg.addParam({paraName: 'selectType', paraValue: this._valCondition.selectType});
    reqInputMsg.addParam({paraName: 'selectCeCd', paraValue: this._valCondition.selectCeCd});

    return await callCmd(reqInputMsg, 'order')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`주문이 성공하였습니다.`, duration: 2});
            this._modalOpenCart = false;
            this.disCartList();
          } else {
            notification.success({placement: 'bottomLeft', message:`주문이 실패하였습니다.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`주문이 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`주문이 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });
  };

  //-----------------------------------
  //  주문 사원 리스트
  //-----------------------------------
  @observable
  _userList = [];

  @computed
  get userList() {
    return this._userList;
  }

  @observable
  _pageInfo = null;

  @computed
  get pageInfo() {
    return this._pageInfo;
  }

  @observable
  _userListLoding = false;

  @computed
  get userListLoding() {
    return this._userListLoding;
  }

  @observable 
  _valCondition = {
    exceptionYn: 'N', // 예외주문여부
    userNm: '',

    pageIdx: 1,
    recordCountPerPage: 15,

    // 선택한 회사타입, 코드
    selectType: '',
    selectCeCd: ''
  };

  @computed
  get valCondition() {
    return this._valCondition;
  }
  
  @action
  onChangValue = (dataNm, dataVal) => {
    this._valCondition = {
      ...this._valCondition,
      [dataNm]: dataVal
    };
  };

  @observable
  _selUserInfo = {
    userId: '',
    jobCd: '',
    userSex: ''
  };

  @computed
  get selUserInfo() {
    return this._selUserInfo;
  }

  @action
  onChangValueUserInfo = (dataNm, dataVal) => {
    this._selUserInfo = {
      ...this._selUserInfo,
      [dataNm]: dataVal
    };
  };

  @action
  orderUserList = async (pageIdx, recordCountPerPage, userNm ) => {
    if (pageIdx !== undefined && pageIdx !== null && this._valCondition.pageIdx !== pageIdx) {
      this._valCondition.pageIdx = pageIdx;
    }
    if (recordCountPerPage !== undefined && recordCountPerPage !== null && this._valCondition.recordCountPerPage !== recordCountPerPage) {
      this._valCondition.recordCountPerPage = recordCountPerPage;
    }

    if (userNm !== undefined && userNm !== null && this._valCondition.userNm !== userNm) {
      this._valCondition.userNm = userNm;
    }

    this._userListLoding = true;

    let addition = new Addition();
    addition.setCmdName('ORDER-USER-LIST');
    addition.setPageYn('Y');
    addition.setPageIndex(this._valCondition.pageIdx);
    addition.setRecordCountPerPage(this._valCondition.recordCountPerPage);

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'userNm', paraValue: this._valCondition.userNm});
    reqInputMsg.addParam({paraName: 'exceptionYn', paraValue: this._valCondition.exceptionYn});
    reqInputMsg.addParam({paraName: 'selectType', paraValue: this._valCondition.selectType});
    reqInputMsg.addParam({paraName: 'selectCeCd', paraValue: this._valCondition.selectCeCd});

    return await callCmd(reqInputMsg, 'userInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          // notification.success({placement: 'bottomLeft', message:`조회가 성공하였습니다.`, duration: 2});
          this._userList = res.result;
          this._pageInfo = res.addition;
          this._userListLoding = false;
          this.orderGoodsList();
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.error({placement: 'bottomLeft', message:`리스트를 불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._userList = [];
          this._pageInfo = null;
          this._userListLoding = false;
          this._goodsList = [];
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`조회가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._userList = [];
        this._pageInfo = null;
        this._userListLoding = false;
        this._goodsList = [];
        console.log('error', error);
      });
  };
  //-----------------------------------
  //  주문 상품 리스트
  //-----------------------------------
  @observable
  _goodsList = [];

  @computed
  get goodsList() {
    return this._goodsList;
  }

  @action
  orderGoodsList = async (userId, jobCd, userSex, noUser = false) => {
    if (userId !== undefined && userId !== null && this._selUserInfo.userId !== userId) {
      this._selUserInfo.userId = userId;
    }
    if (jobCd !== undefined && jobCd !== null && this._selUserInfo.jobCd !== jobCd) {
      this._selUserInfo.jobCd = jobCd;
    }
    if (userSex !== undefined && userSex !== null && this._selUserInfo.userSex !== userSex) {
      this._selUserInfo.userSex = userSex;
    }

    if (this._selUserInfo.userId === '' && noUser === false) {
      this._goodsList = [];
      return;
    }
    
    let addition = new Addition();
    addition.setCmdName('ORDER-GOODS-LIST');
    
    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'userId', paraValue: this._selUserInfo.userId});
    reqInputMsg.addParam({paraName: 'userSex', paraValue: this._selUserInfo.userSex});
    // reqInputMsg.addParam({paraName: 'jobCd', paraValue: null});
    reqInputMsg.addParam({paraName: 'jobCd', paraValue: this._selUserInfo.jobCd});
    // <!!! 수정!!!

    return await callCmd(reqInputMsg, 'goodsInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          // notification.success({placement: 'bottomLeft', message:`조회가 성공하였습니다.`, duration: 2});
          this._goodsList = res.result;
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.error({placement: 'bottomLeft', message:`리스트를 불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._goodsList = [];
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`조회가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._goodsList = [];
        console.log('error', error);
      });
  };

  //-----------------------------------
  //  장바구니 관련
  //-----------------------------------
  /* 장바구니 모달 */
  @observable
  _modalOpenCart = false;

  @computed
  get modalOpenCart() {
    return this._modalOpenCart;
  }

  @action
  onModalCart= (flag) => {
    this._modalOpenCart = flag;
  };

  /* 재고없음 경고 메시지 띄우기 */
  @observable
  _failAlert = false;

  @computed
  get failAlert() {
    return this._failAlert;
  }

  @action
  onFailAlert= () => {
    this._failAlert = false;
  };

  @observable 
  _cartList = [];

  @computed
  get cartList() {
    return this._cartList;
  }

  @action
  disCartList = async () => {
    let addition = new Addition();
    addition.setCmdName('DIS-CART-LIST');
    
    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);

    reqInputMsg.addParam({paraName: 'exceptionYn', paraValue: this._valCondition.exceptionYn});
    reqInputMsg.addParam({paraName: 'selectType', paraValue: this._valCondition.selectType});
    reqInputMsg.addParam({paraName: 'selectCeCd', paraValue: this._valCondition.selectCeCd});

    return await callCmd(reqInputMsg, 'order')
      .then((res) => {
        if (res.error.code === '0000') {
          // notification.success({placement: 'bottomLeft', message:`조회가 성공하였습니다.`, duration: 2});
          this._cartList = res.result;
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.error({placement: 'bottomLeft', message:`리스트를 불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._cartList = [];
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._cartList = [];
        console.log('error', error);
      });
  };

  @action
  merCartInfo = async (data) => {
    // data를 name value로 수정
    let paramData = [];
    Object.keys(data).map((key)=>{return (
      paramData.push({
        paraName: key, paraValue: data[key]
      })
    )});

    let addition = new Addition();
    addition.setCmdName('MER-CART-INFO');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.setParamList(paramData);

    reqInputMsg.addParam({paraName: 'exceptionYn', paraValue: this._valCondition.exceptionYn});
    reqInputMsg.addParam({paraName: 'selectType', paraValue: this._valCondition.selectType});
    reqInputMsg.addParam({paraName: 'selectCeCd', paraValue: this._valCondition.selectCeCd});

    return await callCmd(reqInputMsg, 'order')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`저장이 성공하였습니다.`, duration: 2});
            this.disCartList();
            //this.orderUserList();
          } else {
            // 재고부족 (stockCnt 현재재고)
            if (res.result[0].chkStock === false) {
              this._failAlert = true;
              Modal.warning({
                title: '장바구니 추가/수정 실패',
                content: '   현재 기준으로 재고가 소진되어 해당사이즈로 장바구니 추가/수정이 불가합니다.',
                style: {top:300}
              });
              this.orderUserList();
            }
            notification.success({placement: 'bottomLeft', message:`저장이 실패하였습니다.`, duration: 2});
          }
          this.disCartList();
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();

          }
        } else {
          notification.success({placement: 'bottomLeft', message:`저장이 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`저장이 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });
  };

  @action
  delCartInfo = async (caNo) => {
    let addition = new Addition();
    addition.setCmdName('DEL-CART-INFO');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'caNo', paraValue: caNo});
    
    return await callCmd(reqInputMsg, 'order')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`삭제가 성공하였습니다.`, duration: 2});
            this.disCartList();
            //this.orderUserList();
          } else {
            notification.success({placement: 'bottomLeft', message:`삭제가 실패하였습니다.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`삭제가 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`삭제가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });
  };

  //----------------------------------
  /* 최종주문 주소 가져오기  */
  @observable 
  _lastOrder = null;

  @computed
  get lastOrder() {
    return this._lastOrder;
  }

  @action
  disLastOrder = async () => {
    let addition = new Addition();
    addition.setCmdName('DIS-LAST-ORDER');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    
    reqInputMsg.addParam({paraName: 'selectType', paraValue: this._valCondition.selectType});
    reqInputMsg.addParam({paraName: 'selectCeCd', paraValue: this._valCondition.selectCeCd});

    return await callCmd(reqInputMsg, 'order')
      .then((res) => {
        if (res.error.code === '0000') {
          // notification.success({placement: 'bottomLeft', message:`조회가 성공하였습니다.`, duration: 2});
          if (res.result.length > 0) {
            this._lastOrder = res.result[0];
            // console.log('_lastOrder : ', this._lastOrder);
          } else {
            this._lastOrder = null;
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.error({placement: 'bottomLeft', message:`최종 주문 주소를 가져오기가 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._lastOrder = null;
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`최종 주문 주소를 가져오기가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._lastOrder = null;
        console.log('error', error);
      });
  };

  //----------------------------------
  /* 회사 목록 가져오기  */

  @observable
  _centerOption = [];

  @computed
  get centerOption() {
    return this._centerOption;
  }

  @action
  disCenterList = async (ceBranchCd) => {
    let addition = new Addition();
    addition.setCmdName('DIS-CENTER-LIST');
    addition.setPageYn('N');
    
    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'ceUseYn', paraValue: 'Y'});
    reqInputMsg.addParam({paraName: 'ceBranchCd', paraValue: ceBranchCd});

    return await callCmd(reqInputMsg, 'centerInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          // notification.success({placement: 'bottomLeft', message:`조회가 성공하였습니다.`, duration: 2});
          this._centerOption = res.result;
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.error({placement: 'bottomLeft', message:`리스트를 불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._centerOption = [];
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`조회가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._centerOption = [];
        console.log('error', error);
      });
  };
}